export function shouldShowDecimals(aidYearSummary) {
  return Object.values(aidYearSummary)
    .filter(Number.isFinite)
    .some((value) => value !== parseInt(value));
}
